import ProfileTemplate from './profile.html';
import ProfileDataProviderModule from './profileDataProvider';
import TabsModule from './tabs/tabs';

function ProfileController(
  $scope,
  $rootScope,
  $filter,
  $state,
  $q,
  utils,
  ProfileDataProvider,
  PermissionsService,
) {
  const $t = $filter('translate');
  const isUnlimitedAdmin = PermissionsService.isUlimitedAdmin;

  angular.extend($scope, {
    copyToClipboard: $rootScope.copyToClipboard,
  });

  init();

  // ------

  function init() {
    // NOTE: Dirty hack for fast injecting ready-to-use data provider to child components
    ProfileDataProvider.instance = new ProfileDataProvider();
    const dataProvider = ProfileDataProvider.instance;
    $scope.dataProvider = dataProvider;

    // #region Navigation Tabs

    $scope.tabs = [
      {
        id: 'dashboard',
        name: $t('profile.tabs.dashboard'),
        icon: 'far fa-user',
      },
      {
        id: 'changePassword',
        name: $t('profile.tabs.changePassword'),
        icon: 'far fa-key',
      },
      {
        id: 'totp',
        name: $t('profile.tabs.totp'),
        icon: 'far fa-mobile',
      },
      {
        id: 'addTotp',
        name: $t('profile.tabs.addTotp'),
        icon: 'far fa-mobile',
        hidden: true,
      },
      {
        id: 'deleteAccount',
        name: $t('profile.tabs.deleteAccount'),
        icon: 'far fa-times-octagon',
      },
    ];

    // #endregion

    $scope.loading = true;
    $scope.isError = false;

    $q.when(dataProvider.mainResourceGroup.init())
      .then(() => {
        // Set default tab, only if main resources loaded successfully
        dataProvider.activeTab = $state.params.tab || 'dashboard';
        $scope.loading = false;
      }, (err) => {
        $scope.loading = false;
        $scope.isError = true;
        utils.handleApiError(err);
        dataProvider.goBack();
      });
  }

}

function ProfileRouter(
  $urlRouterProvider,
  $stateProvider
) {
  $stateProvider
    .state('main.profile', {
      url: `/profile/:tab?:from`,
      template: ProfileTemplate,
      controller: ProfileController,
    });
}

export default angular
  .module('main.profile', [
    ProfileDataProviderModule,
    TabsModule
  ])
  .config(ProfileRouter)
  .controller('ProfileController', ProfileController)
  .name;
